import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { Card, Table, Label, Image, Icon, List, Button } from 'semantic-ui-react';

const tableHeaderStyle = {
  textTransform: 'uppercase',
  fontWeight: 600,
};

const statusColours = {
  PENDING: 'orange',
  APPROVED: 'green',
  DECLINED: 'red',
};

const statusLabels = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  DECLINED: 'Declined',
};

const DataRequestWideCard = ({
  id,
  channels,
  requestStatus,
  influencer,
  agency,
  createdBy,
  createdAt,
  requestType,
  onRequestReviewButtonClick,
  isInfluencerMode,
}) => (
  <Card fluid>
    <Card.Content>
      <Label as="a" color={_.get(statusColours, requestStatus, 'grey')} ribbon>
        {_.get(statusLabels, requestStatus, 'Unknown')}
      </Label>
      <Table basic columns={8}>
        <Table.Header>
          <Table.Row>
            {
              !isInfluencerMode && <Table.Cell style={tableHeaderStyle}>Influencer</Table.Cell>
            }
            {
              isInfluencerMode && <Table.Cell style={tableHeaderStyle}>Requested by</Table.Cell>
            }
            <Table.Cell style={tableHeaderStyle}>Requested platforms</Table.Cell>
            <Table.Cell style={tableHeaderStyle}>Request type</Table.Cell>
            <Table.Cell style={tableHeaderStyle}>Created</Table.Cell>
            {
              isInfluencerMode &&
              <Table.Cell style={tableHeaderStyle}>Actions</Table.Cell>
            }
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            {
              !isInfluencerMode &&
              <Table.Cell>
                <Image src={influencer.thumbnail} avatar />
                <span>{ influencer.name }</span>
              </Table.Cell>
            }
            {
              isInfluencerMode &&
              <Table.Cell>
                <span>{ createdBy } @ { agency.name }</span>
              </Table.Cell>
            }
            <Table.Cell>
              <List>
                {
                  _.map(channels, channel => (
                    <List.Item>
                      <Icon name={channel.channel} />
                      {channel.handle}
                    </List.Item>
                  ))
                }
              </List>
            </Table.Cell>
            <Table.Cell>
              { requestType }
            </Table.Cell>
            <Table.Cell>
              {moment(createdAt).format('MMMM Do YYYY, h:mm:ss a')}
            </Table.Cell>
            {
              isInfluencerMode &&
              <Table.Cell>
                <Button id={id} content="Review" icon="eye" onClick={onRequestReviewButtonClick} />
              </Table.Cell>
            }
          </Table.Row>
        </Table.Body>
      </Table>
    </Card.Content>
  </Card>
);

DataRequestWideCard.propTypes = {
  id: PropTypes.string.isRequired,
  influencer: PropTypes.object.isRequired,
  agency: PropTypes.object.isRequired,
  requestStatus: PropTypes.object.isRequired,
  onRequestReviewButtonClick: PropTypes.func,
  createdBy: PropTypes.string.isRequired,
  channels: PropTypes.array.isRequired,
  createdAt: PropTypes.instanceOf(Date).isRequired,
  requestType: PropTypes.string.isRequired,
  isInfluencerMode: PropTypes.bool,
};

DataRequestWideCard.defaultProps = {
  isInfluencerMode: false,
  onRequestReviewButtonClick: _.noop,
};


export default DataRequestWideCard;



/** WEBPACK FOOTER **
 ** ./src/components/data-request-wide-card/index.js
 **/